import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../theme/colors';

export const useCourierDetailsPageHeaderStyles = makeStyles((theme) => ({
  root: {
    padding: '3rem 0',
    color: '#ffffff',
    position: 'relative',
    minHeight: '212px',
    [theme.breakpoints.down('sm')]: {
      rowGap: '1.5rem'
    }
  },
  courierName: {
    display: 'flex',
    flexDirection: 'row'
  },
  breadcrumbs: {
    color: '#ffffffc4',
    fontSize: '1rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  breadcrumbLink: {
    color: Colors.white,
    textDecoration: 'underline',
    '&:hover, &:focus, &:active': {
      color: Colors.white
    }
  },
  breadcrumbSeparator: {
    margin: '0 0.5rem',
    opacity: 0.6
  },
  // Carrier logos vary wildly in aspect ratio, so cap the height and let the width follow
  // rather than letting a wide logo stretch the header past its 212px minimum.
  carrierImage: {
    maxHeight: '48px',
    maxWidth: '100%',
    objectFit: 'contain',
    marginTop: '0.5rem'
  },
  // The logo keeps its own top margin, so the registration text centres against the logo itself.
  carrierRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '1rem'
  },
  registration: {
    fontSize: '14px',
    margin: '0.5rem 0 0'
  },
  // Every state names its own colour: the global `a:hover` reboot otherwise turns it dark on hover.
  registrationLink: {
    color: Colors.white,
    textDecoration: 'underline',
    '&:hover, &:focus, &:active': {
      color: Colors.white
    }
  },
  signIn: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '6px'
  },
  signInRow: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '4px',
    fontSize: '14px',
    lineHeight: '20px',
    margin: 0
  },
  // Sized to the line so the mobile row is no taller than the others.
  signInIcon: {
    height: '18px',
    width: '18px'
  },
  courierImage: {
    maxHeight: '96px',
    maxWidth: '100%',
    objectFit: 'contain',
    borderRadius: '4px',
    marginTop: '0.5rem'
  },
  info: {
    fontSize: '14px',
    marginBottom: '1rem'
  },
  capabilities: {
    textTransform: 'uppercase',
    color: '#ffffffc4',
    fontSize: '14px'
  },
  capabilitiesIcon: {
    height: 24,
    width: 24
  },
  actionButtonBox: {
    position: 'absolute',
    top: '3rem',
    right: 0
  }
}));
